import { render } from "./Navigation.vue?vue&type=template&id=2684d8dc"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=2684d8dc&lang=less"
script.render = render

export default script